// Camada de persistência dos checklists.
//
// Versão conectada à API real do backend (tenant-service), substituindo
// o armazenamento em localStorage. Mantém a mesma interface (list, get,
// save, remove) usada pelos componentes — agora todas retornam Promises.
import API_BASE from "../../config.js";
import { authFetch } from "../../services/authFetch";

const API = `${API_BASE}/api/v1/checklist`;

function authHeaders() {
  return { "Content-Type": "application/json" };
}

export const checklistService = {
  async list(workshopId) {
    try {
      const r = await authFetch(`${API}/${workshopId}`, { headers: authHeaders() });
      if (!r.ok) return [];
      const data = await r.json();
      return Array.isArray(data)
        ? data.sort((a, b) => new Date(b.updatedAt || b.updated_at) - new Date(a.updatedAt || a.updated_at))
        : [];
    } catch {
      return [];
    }
  },

  async get(workshopId, checklistId) {
    try {
      const r = await authFetch(`${API}/${workshopId}/${checklistId}`, { headers: authHeaders() });
      if (!r.ok) return null;
      return await r.json();
    } catch {
      return null;
    }
  },

  async save(workshopId, checklist) {
    const r = await authFetch(`${API}/${workshopId}`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify(checklist),
    });
    if (!r.ok) {
      const erro = await r.json().catch(() => ({}));
      throw new Error(erro.detail || "Erro ao salvar checklist");
    }
    return { ...checklist, updatedAt: new Date().toISOString() };
  },

  async remove(workshopId, checklistId) {
    const r = await authFetch(`${API}/${workshopId}/${checklistId}`, {
      method: "DELETE",
      headers: authHeaders(),
    });
    if (!r.ok) throw new Error("Erro ao excluir checklist");
  },

  async obterLimites(workshopId, checklistId) {
    try {
      const r = await authFetch(`${API}/${workshopId}/${checklistId}/limites`, { headers: authHeaders() });
      if (!r.ok) return { max_fotos_itens: 5, usados_fotos_itens: 0, max_fotos_avarias: 3, usados_fotos_avarias: 0 };
      return await r.json();
    } catch {
      return { max_fotos_itens: 5, usados_fotos_itens: 0, max_fotos_avarias: 3, usados_fotos_avarias: 0 };
    }
  },
};
